export default {
  title: 'Playground',

  navigation: {
    squircle: 'Squircle',
    sticker: 'Sticker',
    button: 'Button',
    tag: 'Tag',
    gSelect: 'GSelect',
    gTextField: 'GTextField',
    gTextarea: 'GTextarea',
    gSnackbar: 'GSnackbar',
    contactLists: 'ContactLists'
  },

  squircle: {
    title: 'Squircle'
  },

  sticker: {
    title: 'Sticker',

    statuses: {
      active: 'Активный'
    }
  },

  button: {
    title: 'Button'
  },

  tag: {
    title: 'Tag'
  },

  g: {
    select: {
      title: 'GSelect'
    },

    'text-field': {
      title: 'GTextField'
    },

    textarea: {
      title: 'GTextarea'
    },

    snackbar: {
      title: 'GSnackbar'
    }
  },

  contactLists: {
    title: 'ContactLists',

    groups: {
      controls: 'Управление',
      transport: 'Транспорт и маршрут',
      create: 'Создание',
      get: 'Получение',
      find: 'Поиск',
      update: 'Обновление',
      remove: 'Удаление'
    },

    labels: {
      controls: 'Прогон кейсов',
      fixture: 'Фикстура',
      expected: 'Ожидание',
      actual: 'Ответ',
      cleanupError: 'Созданная запись не удалена',
      log: 'Лог запросов',
      logEmpty: 'Запросов пока не было'
    },

    actions: {
      run: 'Запустить',
      runAll: 'Запустить все',
      createFixture: 'Создать фикстуру',
      removeFixture: 'Удалить фикстуру',
      reset: 'Сбросить',
      clearLog: 'Очистить лог'
    },

    cases: {
      transport: {
        invalidToken: 'Токен в заголовке Authorization не проходит проверку',
        unknownPath: 'Путь не описан в маршрутах API',
        wrongMethod: 'Метод PATCH не описан для ресурса',
        malformedBody: 'Тело запроса не является корректным JSON'
      },

      create: {
        emptyBody: 'Создание без обязательных полей',
        emptyTitle: 'Пустой title',
        htmlTitle: 'title состоит только из HTML тега и вырезается санитайзером',
        longTitle: 'title длиннее 150 символов',
        forbiddenCharacterTitle: 'title содержит символ вне разрешённого набора',
        numberTitle: 'title передан числом и приводится к строке',
        unknownType: 'Неизвестный type подменяется на regular',
        invalidOwnerId: 'Некорректный OwnerId отбрасывается и заменяется владельцем токена'
      },

      get: {
        missing: 'Запрос несуществующего списка',
        invalidId: 'Идентификатор не приводится к типу uuid',
        objectScope: 'Параметр $scope передан объектом вместо строки или массива'
      },

      find: {
        limitNotNumber: 'Параметр $limit не число',
        limitNegative: 'Параметр $limit меньше нуля',
        offsetNotNumber: 'Параметр $offset не число',
        objectOrder: 'Параметр $order передан объектом вместо строки или массива',
        invalidIdFilter: 'Фильтр id с некорректным uuid отбрасывается и выборка возвращается целиком'
      },

      update: {
        missing: 'Обновление несуществующего списка',
        invalidId: 'Идентификатор не приводится к типу uuid',
        emptyTitle: 'Пустой title у существующего списка',
        longTitle: 'title длиннее 150 символов у существующего списка',
        forbiddenCharacterTitle: 'title с символом вне разрешённого набора у существующего списка',
        idInBody: 'Поле id в теле запроса игнорируется'
      },

      remove: {
        missing: 'Удаление несуществующего списка',
        invalidId: 'Идентификатор не приводится к типу uuid'
      }
    }
  },

  groups: {
    sizes: 'Размеры',
    lineHeight: 'Line-height',
    modes: 'Режимы',
    states: 'Состояния',
    filledColors: 'Цвета filled',
    outlineColors: 'Цвета outline',
    iconContent: 'Содержимое с иконкой',
    iconSizes: 'Иконка и подпись: размеры',
    iconOnlySizes: 'Только иконка: размеры',
    iconModes: 'Иконка и подпись: режимы',
    iconSamples: 'Разные иконки',
    iconStates: 'Состояния с иконкой',
    content: 'Контент',
    colors: 'Цвета',
    links: 'Ссылки и клик',
    actions: 'Действия',
    borders: 'Границы',
    progress: 'Прогресс',
    messages: 'Подсказки и валидация',
    multiple: 'Множественный выбор',
    selection: 'Выбранный элемент',
    dropdown: 'Выпадающий список',
    rows: 'Высота и ширина',
    types: 'Типы',
    interactive: 'Интерактивные примеры',
    iconSVG: 'iconSVG',
    icons: 'Иконки',
    affixes: 'Префиксы и суффиксы',
    tooltip: 'Tooltip',
    fullWidth: 'Полная ширина',
    slot: 'Слот',
    features: 'Свойства',
    as: 'As',
    styles: 'Оформление',
    limits: 'Ограничения',
    resize: 'Resize',
    itemConfig: 'Настройка items',
    freeInput: 'Free input',
    service: 'Загрузка из сервиса',
    button: 'Кнопка',
    badges: 'Badge',
    width: 'Ширина',
    target: 'Target',
    allIcons: 'Все иконки',
    allColors: 'Все цвета',
    duration: 'Длительность'
  },

  empty: {
    icons: 'Ничего не найдено'
  },

  labels: {
    button: 'Кнопка',
    copyIcon: 'Нажмите, чтобы скопировать иконку',
    copyColor: 'Нажмите, чтобы скопировать цвет',
    defaultSlot: 'Слот по умолчанию',
    detailsAndCount: 'Подсказка и счётчик',
    detailsFalse: 'Без блока details',
    dropdownSlots: 'menuProps, icons и slots',
    growFalse: 'grow выключен с многострочным значением',
    growInput: 'Рост высоты при вводе',
    growLongValue: 'grow по многострочному значению',
    growShortValue: 'grow по короткому значению',
    iconColorAndSize: 'iconColor и iconSize',
    inputError: 'Текст ошибки',
    inputHint: 'Текст подсказки',
    inputLabel: 'Метка',
    inputPlaceholder: 'Текст подсказки в поле',
    inputValue: 'Значение поля',
    interactiveTag: 'Удаляемый тег',
    itemConfig: 'itemsPrepend, itemsDisabled, itemTitle, itemValue, itemDisabled и picks',
    longLabel: 'Очень длинная подпись, которая не помещается в одну строку',
    maskCard: 'Маска карты',
    maskPhone: 'Маска телефона',
    multipleHideSelections: 'multiple и hideSelections',
    restoreTag: 'Вернуть тег',
    runAllCases: 'Запустить все примеры',
    servicePaths: 'service, pathToId, pathToTitle и translatePath',
    singleClearable: 'single и clearable',
    snackbarActionResult: 'Действие снекбара выполнено',
    snackbarDurationText: 'Снекбар с длительностью в секундах:',
    snackbarQueueText: 'Снекбар очереди',
    snackbarText: 'Короткий текст снекбара',
    stickerLabel: 'Описание стикера',
    stickerValue: 'Заголовок стикера',
    tag: 'Тег',
    tooltip: 'Подсказка'
  }
}
